import actionConsts from '../../constants/actions';

const initialState = {
    width: window.innerWidth,
    height: window.innerHeight
};

const dimension = (state = initialState, action = {}) => {
    switch (action.type) {
        case actionConsts.CHANGE_WIDTH_AND_HEIGHT:
            return {
                width: window.innerWidth,
                height: window.innerHeight
            };

        default:
            return state;
    }
};

export default dimension;


// WEBPACK FOOTER //
// /src/reducers/uiState/dimension.js